/**
 * @file
 * @prettier
 */

import { add_deviceprint } from "@/common/browserFingerprint.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeNewAccountSecurityPage() {
  customValidationInit(false);
  aspControlValidationInit();

  $(document).tooltip();

  // Populate the device print
  $("[id$='hdndevicePrint']").val(add_deviceprint());
}
